import type { AgendaRegistration } from '@/shared/navigation';
import { jobDetailAgenda } from './detail/jobDetailAgenda';
import { JobDetailPage } from './detail/JobDetailPage';
import { jobsOverviewAgenda } from './overview/jobsOverviewAgenda';
import { JobsOverviewPage } from './overview/JobsOverviewPage';

/**
 * Agendy jobs modulu: centrální přehled „Operace na pozadí" + detail jobu.
 * Bez permission — joby vidí každý přihlášený (seznam je stejně per-user).
 */
export const jobsAgendas: AgendaRegistration[] = [
  { agenda: jobsOverviewAgenda, component: JobsOverviewPage },
  { agenda: jobDetailAgenda, component: JobDetailPage },
];
